import { render, staticRenderFns } from "./SchoolHistoryTableForm.vue?vue&type=template&id=d20d8d7a"
import script from "./SchoolHistoryTableForm.vue?vue&type=script&lang=js"
export * from "./SchoolHistoryTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports